import React from "react";
import { Backdrop, CircularProgress, Typography, Box } from "@mui/material";
import { useLoading } from "../context/LoadingContext";

const GlobalLoader = () => {
  const { isLoading } = useLoading();

  return (
    <Backdrop
      open={isLoading}
      sx={{
        color: "#fff",
        zIndex: 9999,
        flexDirection: "column",
        gap: 2,
        backgroundColor: "rgba(0, 0, 0, 0.55)",
        backdropFilter: "blur(3px)",
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: 2,
          backgroundColor: "rgba(255, 255, 255, 0.1)",
          borderRadius: 3,
          padding: "32px 48px",
          boxShadow: "0 8px 32px rgba(0,0,0,0.3)",
          border: "1px solid rgba(255,255,255,0.2)",
        }}
      >
        <CircularProgress
          color="inherit"
          size={56}
          thickness={4}
          sx={{ color: "#ffffff" }}
        />
        <Typography
          variant="body1"
          sx={{
            fontWeight: 600,
            letterSpacing: "0.08em",
            color: "#ffffff",
            fontSize: "1rem",
          }}
        >
          Tafadhali subiri...
        </Typography>
      </Box>
    </Backdrop>
  );
};

export default GlobalLoader;
